import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register service worker for PWA support
serviceWorkerRegistration.register({
    onSuccess: () => {
        console.log('[PWA] Cached for offline use.');
    },
    onUpdate: (registration) => {
        // When a new version is available, show a toast and reload
        const confirmed = window.confirm(
            'A new version of Percept Pulse is available. Reload to update?'
        );
        if (confirmed && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            window.location.reload();
        }
    },
});

// Handle navigation messages from service worker (push notification clicks)
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'NAVIGATE' && event.data?.url) {
            window.location.href = event.data.url;
        }
    });
}


// Clear PWA icon badge when app is opened or gains focus
if ('clearAppBadge' in navigator) {
    navigator.clearAppBadge().catch(() => {});
}
window.addEventListener('focus', () => {
    if ('clearAppBadge' in navigator) navigator.clearAppBadge().catch(() => {});
});